import {useContext} from 'react';
import {useParams, useRouteMatch} from 'react-router-dom';
import {AssociateDeviceForm} from '../../../../../../../components/associate-device-form/associate-device-form';
import {OfficeContext} from '../../../../../../../contexts/office/context';
import {OfficeContextType} from '../../../../../../../contexts/office/types';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';

export default function SeniorAssociateDeviceSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id: string} = useParams();

  // Get context
  const officeContext: OfficeContextType = useContext(OfficeContext);

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  const userName = (officeContext.state.userForm?.user.displayName ||
    officeContext.state.userForm?.user.name)!;

  return (
    <AssociateDeviceForm
      caregiverMode={CaregiverMode.SystemAdministrator}
      userId={id}
      userName={userName}
      redirectUrl={url.replace('/associate', '')}
    />
  );
}
